import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useExperienceSlotStatuses } from '../../../utilities/hooks/useExperienceSlotStatuses';

const MultipleCustomSlotCheckbox = ({
	label,
    checbboxObj,
    itemKey,
	onFilterSlotSelected,
	setEnableScheduling,
	filterCount,
	name = null,
	type
}) => {
	const getSize = () => {
		if (!type) {
			return '16px';
		} else {
			if (type === 1) {
				return '16px';
			} else if (type === 2) {
				return '24px';
			}
		}
	};

    const slotStatuses = useExperienceSlotStatuses();
    const [checkboxChecked, SetCheckboxChecked] = useState(false);
   
    useEffect(() => {
		SetCheckboxChecked(checbboxObj[itemKey]);
	}, []);

    const setCheckboxCheckedChoose = (itemKey) => {
		let statusIds = JSON.parse(localStorage.getItem('calendar_filter_slot')) || [];
        SetCheckboxChecked(!checbboxObj[itemKey]);
        checbboxObj[itemKey] = !checbboxObj[itemKey];
        Object.keys(slotStatuses).map((slotStatus) => {
            if (slotStatus === itemKey) {
				if (checbboxObj[slotStatus] === true) {
					if (!statusIds.includes(slotStatus)) {
						statusIds.push(slotStatus);
					}
				} else {
					if (statusIds.includes(slotStatus)) { 
						for( var i = 0; i < statusIds.length; i++) { 
							if ( statusIds[i] === slotStatus) { 
								statusIds.splice(i, 1); 
							}
						
						}
					}
				}

            }
        });

		if (statusIds.length > 0) {
			localStorage.setItem('calendar_filter_slot', JSON.stringify(statusIds));
			setEnableScheduling(true);
		} else {
			localStorage.removeItem('calendar_filter_slot');
			if (filterCount - 1 <= 0) {
				setEnableScheduling(false);
			}
		}
		
		onFilterSlotSelected(statusIds);
    }

	return (
		<div
			onClick={() => setCheckboxCheckedChoose(itemKey)}
			className="form-check-container"
			style={{ marginLeft: '0' }}
			data-testid={name ? name : 'custom-checkbox'}
		>
			<div
				style={{ width: getSize(), height: getSize() }}
				className={
					'custom-checkbox ' +
					(checkboxChecked
						? type === 1 || !type
							? 'custom-checkbox-checked'
							: 'custom-checkbox-checked-medium'
						: 'custom-checkbox')
				}
			/>
			<label
				style={{ marginBottom: 0, marginLeft: '10px', fontWeight: 400 }}
				className="checkbox-label"
			>
				{label}
			</label>
			{name ? (
				<input
					name={name}
					type="checkbox"
					style={{ display: 'none' }}
					checked={checkboxChecked}
					readOnly={true}
					data-testid={name}
				/>
			) : null}
		</div>
	);
};

MultipleCustomSlotCheckbox.propTypes = {
	label: PropTypes.string,
	name: PropTypes.string,
	onChange: PropTypes.func,
	type: PropTypes.number,
	itemKey: PropTypes.string,
    checbboxObj: PropTypes.array,
	onFilterSlotSelected: PropTypes.func,
	setEnableScheduling: PropTypes.func,
	filterCount: PropTypes.number
};

export default MultipleCustomSlotCheckbox;
